import { Flex } from '@chakra-ui/react'

import Logo from 'assets/logo.svg'

import theme from 'theme'

import backgroundSrc from './assets/bg.svg'

export const splashContainerProps = {
  // backgroundImage: backgroundSrc,
  backgroundSize: 'cover',
  // backgroundColor: theme.baseColors.brand.main,
  backgroundBlendMode: 'multiply',
  backgroundRepeat: 'no-repeat',
}

export const splashContainerFilterProps = {
  // backdropFilter: 'blur(8px) saturate(110%) contrast(150%) brightness(45%)',
}

type Props = {
  showContainer?: boolean
  showLogo?: boolean
}

const SplashForeground = ({ showLogo }: Pick<Props, 'showLogo'>) => (
  <Flex w="100%" h="100%" flex={1} direction="column" position="absolute" top="0" left="0">
    <Flex flex={0.75} p="36px" align="center" justify="center">
      {showLogo && <img src={Logo} alt="Logo" width="360px" height="63px" />}
    </Flex>
  </Flex>
)

const Splash = ({ showContainer, showLogo }: Props) =>
  showContainer ? (
    <Flex align="center" {...splashContainerProps}>
      <Flex w="100%" h="100vh" direction="column" {...splashContainerFilterProps}>
        <SplashForeground showLogo={showLogo} />
      </Flex>
    </Flex>
  ) : (
    <SplashForeground showLogo={showLogo} />
  )

export default Splash
